// Builds wa.me links so enquiries arrive on SPC's WhatsApp, pre-filled.
const NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");

const TITLES = { sourcing: "Sourcing enquiry", rnd: "R&D project enquiry", contact: "General enquiry" };

export const whatsappLink = (text = "Hello SPC, I would like to start a conversation.") =>
  `https://wa.me/${NUMBER}?text=${encodeURIComponent(text)}`;

export const enquiryMessage = (formType, fields, values, reference) => {
  const lines = fields
    .filter((f) => f.type !== "checkbox" && values[f.name])
    .map((f) => `• ${f.label}: ${values[f.name]}`);
  const ref = reference ? ` (ref ${reference})` : "";
  return `Hello SPC, ${TITLES[formType] || "Enquiry"}${ref}\n\n${lines.join("\n")}`;
};
